module.exports = __webpack_public_path__ + "img/career-building.73d03b20.png";